import { DEFAULT_CURRENCY_CODE, inject, Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'currencyCode',
	standalone: true,
})
export class CurrencyCodePipe implements PipeTransform {
	protected readonly DEFAULT_CURRENCY_CODE = inject(DEFAULT_CURRENCY_CODE);

	private readonly currencySym: { [key: string]: string } = {
		usd: '$',
		try: '₺',
		euro: '€',
	};

	transform(id?: string): string {
		const key = String(id ?? this.DEFAULT_CURRENCY_CODE).toLowerCase();
		return this.currencySym[key] || '';
	}
}
